import React, { memo, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import useImageError from '@/hooks/use-image';
import styles from './index.module.scss';
interface LogoWithTextProps {
  //logo img src
  src?: string;
  chName: string;
  ehName?: string;
  logoClass?: string;
  spanClass?: string;
  //显示品牌名称长度
  len?: number;
  width: number;
  borderRadios: number;
  className?: string;
}
const LogoWithText: React.FC<LogoWithTextProps> = ({
  src,
  chName,
  ehName,
  logoClass,
  spanClass,
  len = 4,
  width,
  borderRadios,
  className,
}) => {
  const [setImg, hasError] = useImageError();

  /**
   * 处理四字时两字换行
   */
  const formatName = useCallback(
    name => {
      if (!name) return '';
      if (
        /^[\u4e00-\u9fa5]/.test(name?.slice(0, len)) &&
        (len === 4 || len === 6) &&
        name?.length >= 4 &&
        name?.length < 6
      ) {
        return `${name.slice(0, 2)}\n${name.slice(2, 4)}`;
      } else {
        return name?.slice(0, len);
      }
    },
    [len]
  );

  const textLogoDom = useMemo(() => {
    return (
      <span
        className={classNames([styles.logoSpan, spanClass])}
        style={{
          width: `${width}px`,
          height: `${width}px`,
          borderRadius: borderRadios === 100 ? '100%' : `${borderRadios}px`,
        }}
      >
        {formatName(chName || ehName)}
      </span>
    );
  }, [borderRadios, chName, ehName, formatName, spanClass, width]);

  if (hasError) {
    return textLogoDom;
  }

  return (
    <div className={className}>
      {src ? (
        <img
          ref={setImg}
          className={logoClass}
          src={src}
          width={width}
          height={width}
          style={{ borderRadius: borderRadios === 100 ? '100%' : `${borderRadios}px` }}
          alt={ehName || chName}
        />
      ) : (
        textLogoDom
      )}
    </div>
  );
};
export default memo(LogoWithText);
